module.exports = __webpack_public_path__ + "static/media/pink_blue1.3dc82f40.jpg";